import { render } from "./CancellationModal.vue?vue&type=template&id=3ebe70aa"
import script from "./CancellationModal.vue?vue&type=script&lang=js"
export * from "./CancellationModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/api-staging.champagne-booking.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__